import { palette, heading, paragraph, chart, fonts, assets, shadows, gradients, radials, uniques, } from "./palette";
import type { Theme, Strata, ThemePalette, } from "@bracket/ui/types";



export const dark: Theme = {
	name: "dark",
	assets,
	fonts,
	typeface: {
		p: paragraph,
		...heading,
	},
	chart,
	shadows,
	gradients,
	radials,
	...palette,
	uniques,
	// @ts-expect-error - TODO: fix this
	strata: function ( level?: Strata ) {
		const key = level ? level === "default" ? "surface_container" : `surface_container_${level}` : "surface_container";
		const selection = this[key as keyof ThemePalette];
		return level ? this[key as keyof ThemePalette] : this.surface_container;
	},
	unique: function ( key: string, ) {
		return uniques[key as keyof typeof uniques] || {};
	}
};
